module.exports = __webpack_public_path__ + "media/images/articles/manners/cover-1b5e696916040040d6e311441678c162.png";